import { inLifeRoutes } from '@in-life/routes';

import { useFeatureFlag } from '@hooks/useFeatureFlag';
import { JourneyModeResolver } from '@routing/JourneyModeResolver';
import { useMode } from '@store/journey/selectors';
import { JOURNEY_MODE } from '@store/journey/slice';

import { Router } from './Router';
import { routesConfig } from './routesConfig';

const AppShell = () => {
  const mode = useMode();
  const { value: isInLifeEnabled, loading: isInLifeEnabledLoading } =
    useFeatureFlag('in-life-journey-enabled', false);

  if (isInLifeEnabledLoading) {
    return null;
  }

  if (isInLifeEnabled) {
    switch (mode) {
      case JOURNEY_MODE.RESOLVING:
        return <JourneyModeResolver />;
      case JOURNEY_MODE.INLIFE:
        return <Router key={mode} routes={inLifeRoutes} />;
      default:
        return <Router key={mode} routes={routesConfig} />;
    }
  }

  return <Router key={mode} routes={routesConfig} />;
};

export { AppShell };
